import { Loader } from '@googlemaps/js-api-loader';
import React from 'react';
import Styles from './GoogleMaps.scss';
import { getBearingForPanorama } from './Helpers';

export interface IStreetViewPosition {
    lat: number;
    lng: number;
}

let didStreetViewInit = false;
const streetViewOptions: google.maps.StreetViewPanoramaOptions = {
    position: { lat: 0, lng: 0 },
    pov: {
        heading: 270,
        pitch: 0,
    },
    visible: true,
    fullscreenControl: false,
    disableDefaultUI: true,
};

interface IStreetViewComponentProps {
    id?: string;
    onReposition: (lat: number, lng: number) => void;
    onPovChange: (heading: number) => void;
    initialCoordinates: number[];
}

export class StreetViewComponent extends React.Component<IStreetViewComponentProps> {
    id: string;
    panorama: google.maps.StreetViewPanorama;
    streetViewService: google.maps.StreetViewService;
    constructor(props: IStreetViewComponentProps) {
        super(props);
        this.id = props.id ?? 'streetViewContainer';
        this.setLocation = this.setLocation.bind(this);
        this.handlePositionChanged = this.handlePositionChanged.bind(this);
        this.handlePovChanged = this.handlePovChanged.bind(this);
    }

    async setLocation(longitude: number, latitude: number) {
        // find the nearest street view location to the pole
        if (!this.streetViewService) {
            return;
        }

        try {
            const panorama = await this.streetViewService.getPanorama({
                location: new google.maps.LatLng({
                    lat: latitude,
                    lng: longitude,
                }),
            });

            this.panorama.setPano(panorama.data.location.pano);

            // look at the pole
            const latlng = panorama.data.location.latLng;
            this.panorama.setPov({
                heading: getBearingForPanorama(
                    latlng.lat(),
                    latlng.lng(),
                    latitude,
                    longitude
                ),
                pitch: 25,
            });
        } catch (e) {
            console.log(e);
        }
    }

    componentWillUnmount() {
        didStreetViewInit = false;
    }

    handlePositionChanged() {
        const newPosition = this.panorama.getPosition();
        this.props.onReposition(newPosition.lat(), newPosition.lng());
    }

    handlePovChanged() {
        const newPov = this.panorama.getPov();
        this.props.onPovChange(newPov.heading);
    }

    render() {
        if (!didStreetViewInit) {
            const loader = new Loader({
                apiKey: process.env.GOOGLE_API_KEY,
            });
            loader
                .importLibrary('streetView')
                .then(({ StreetViewPanorama, StreetViewService }) => {
                    didStreetViewInit = true;
                    this.panorama = new StreetViewPanorama(
                        document.getElementById(this.id),
                        streetViewOptions
                    );
                    this.streetViewService = new StreetViewService();

                    this.setLocation(
                        this.props.initialCoordinates[0],
                        this.props.initialCoordinates[1]
                    );

                    this.panorama.addListener(
                        'position_changed',
                        this.handlePositionChanged
                    );

                    this.panorama.addListener(
                        'pov_changed',
                        this.handlePovChanged
                    );
                });
        }

        return <div id={this.id} className={Styles.mapContainer} />;
    }
}
